export const coins_pairs: {
  [coin: string]: { coin: string; baseCoin: string; quoteCoin: string };
} = {
  ETHBTC: {
    coin: 'ETHBTC',
    baseCoin: 'ETH',
    quoteCoin: 'BTC',
  },
  LTCBTC: {
    coin: 'LTCBTC',
    baseCoin: 'LTC',
    quoteCoin: 'BTC',
  },
  BNBBTC: {
    coin: 'BNBBTC',
    baseCoin: 'BNB',
    quoteCoin: 'BTC',
  },
  NEOBTC: {
    coin: 'NEOBTC',
    baseCoin: 'NEO',
    quoteCoin: 'BTC',
  },
  QTUMETH: {
    coin: 'QTUMETH',
    baseCoin: 'QTUM',
    quoteCoin: 'ETH',
  },
  EOSETH: {
    coin: 'EOSETH',
    baseCoin: 'EOS',
    quoteCoin: 'ETH',
  },
  BNBETH: {
    coin: 'BNBETH',
    baseCoin: 'BNB',
    quoteCoin: 'ETH',
  },
  BTCUSDT: {
    coin: 'BTCUSDT',
    baseCoin: 'BTC',
    quoteCoin: 'USDT',
  },
  ETHUSDT: {
    coin: 'ETHUSDT',
    baseCoin: 'ETH',
    quoteCoin: 'USDT',
  },
  LRCBTC: {
    coin: 'LRCBTC',
    baseCoin: 'LRC',
    quoteCoin: 'BTC',
  },
  LRCETH: {
    coin: 'LRCETH',
    baseCoin: 'LRC',
    quoteCoin: 'ETH',
  },
  QTUMBTC: {
    coin: 'QTUMBTC',
    baseCoin: 'QTUM',
    quoteCoin: 'BTC',
  },
  NEOETH: {
    coin: 'NEOETH',
    baseCoin: 'NEO',
    quoteCoin: 'ETH',
  },
  IOTABTC: {
    coin: 'IOTABTC',
    baseCoin: 'IOTA',
    quoteCoin: 'BTC',
  },
  IOTAETH: {
    coin: 'IOTAETH',
    baseCoin: 'IOTA',
    quoteCoin: 'ETH',
  },
  LINKBTC: {
    coin: 'LINKBTC',
    baseCoin: 'LINK',
    quoteCoin: 'BTC',
  },
  LINKETH: {
    coin: 'LINKETH',
    baseCoin: 'LINK',
    quoteCoin: 'ETH',
  },
  EOSBTC: {
    coin: 'EOSBTC',
    baseCoin: 'EOS',
    quoteCoin: 'BTC',
  },
  ETCETH: {
    coin: 'ETCETH',
    baseCoin: 'ETC',
    quoteCoin: 'ETH',
  },
  ETCBTC: {
    coin: 'ETCBTC',
    baseCoin: 'ETC',
    quoteCoin: 'BTC',
  },
  ZECBTC: {
    coin: 'ZECBTC',
    baseCoin: 'ZEC',
    quoteCoin: 'BTC',
  },
  ZECETH: {
    coin: 'ZECETH',
    baseCoin: 'ZEC',
    quoteCoin: 'ETH',
  },
  DASHBTC: {
    coin: 'DASHBTC',
    baseCoin: 'DASH',
    quoteCoin: 'BTC',
  },
  DASHETH: {
    coin: 'DASHETH',
    baseCoin: 'DASH',
    quoteCoin: 'ETH',
  },
  TRXBTC: {
    coin: 'TRXBTC',
    baseCoin: 'TRX',
    quoteCoin: 'BTC',
  },
  TRXETH: {
    coin: 'TRXETH',
    baseCoin: 'TRX',
    quoteCoin: 'ETH',
  },
  XRPBTC: {
    coin: 'XRPBTC',
    baseCoin: 'XRP',
    quoteCoin: 'BTC',
  },
  XRPETH: {
    coin: 'XRPETH',
    baseCoin: 'XRP',
    quoteCoin: 'ETH',
  },
  ENJBTC: {
    coin: 'ENJBTC',
    baseCoin: 'ENJ',
    quoteCoin: 'BTC',
  },
  ENJETH: {
    coin: 'ENJETH',
    baseCoin: 'ENJ',
    quoteCoin: 'ETH',
  },
  BNBUSDT: {
    coin: 'BNBUSDT',
    baseCoin: 'BNB',
    quoteCoin: 'USDT',
  },
  XMRBTC: {
    coin: 'XMRBTC',
    baseCoin: 'XMR',
    quoteCoin: 'BTC',
  },
  XMRETH: {
    coin: 'XMRETH',
    baseCoin: 'XMR',
    quoteCoin: 'ETH',
  },
  BATBTC: {
    coin: 'BATBTC',
    baseCoin: 'BAT',
    quoteCoin: 'BTC',
  },
  BATETH: {
    coin: 'BATETH',
    baseCoin: 'BAT',
    quoteCoin: 'ETH',
  },
  NEOUSDT: {
    coin: 'NEOUSDT',
    baseCoin: 'NEO',
    quoteCoin: 'USDT',
  },
  NEOBNB: {
    coin: 'NEOBNB',
    baseCoin: 'NEO',
    quoteCoin: 'BNB',
  },
  MANABTC: {
    coin: 'MANABTC',
    baseCoin: 'MANA',
    quoteCoin: 'BTC',
  },
  MANAETH: {
    coin: 'MANAETH',
    baseCoin: 'MANA',
    quoteCoin: 'ETH',
  },
  IOTABNB: {
    coin: 'IOTABNB',
    baseCoin: 'IOTA',
    quoteCoin: 'BNB',
  },
  ADABTC: {
    coin: 'ADABTC',
    baseCoin: 'ADA',
    quoteCoin: 'BTC',
  },
  ADAETH: {
    coin: 'ADAETH',
    baseCoin: 'ADA',
    quoteCoin: 'ETH',
  },
  XLMBTC: {
    coin: 'XLMBTC',
    baseCoin: 'XLM',
    quoteCoin: 'BTC',
  },
  XLMETH: {
    coin: 'XLMETH',
    baseCoin: 'XLM',
    quoteCoin: 'ETH',
  },
  XLMBNB: {
    coin: 'XLMBNB',
    baseCoin: 'XLM',
    quoteCoin: 'BNB',
  },
  LTCETH: {
    coin: 'LTCETH',
    baseCoin: 'LTC',
    quoteCoin: 'ETH',
  },
  LTCUSDT: {
    coin: 'LTCUSDT',
    baseCoin: 'LTC',
    quoteCoin: 'USDT',
  },
  LTCBNB: {
    coin: 'LTCBNB',
    baseCoin: 'LTC',
    quoteCoin: 'BNB',
  },
  ZILBTC: {
    coin: 'ZILBTC',
    baseCoin: 'ZIL',
    quoteCoin: 'BTC',
  },
  ZILETH: {
    coin: 'ZILETH',
    baseCoin: 'ZIL',
    quoteCoin: 'ETH',
  },
  ZILBNB: {
    coin: 'ZILBNB',
    baseCoin: 'ZIL',
    quoteCoin: 'BNB',
  },
  QTUMUSDT: {
    coin: 'QTUMUSDT',
    baseCoin: 'QTUM',
    quoteCoin: 'USDT',
  },
  ADAUSDT: {
    coin: 'ADAUSDT',
    baseCoin: 'ADA',
    quoteCoin: 'USDT',
  },
  ADABNB: {
    coin: 'ADABNB',
    baseCoin: 'ADA',
    quoteCoin: 'BNB',
  },
  XRPUSDT: {
    coin: 'XRPUSDT',
    baseCoin: 'XRP',
    quoteCoin: 'USDT',
  },
  BTCTUSD: {
    coin: 'BTCTUSD',
    baseCoin: 'BTC',
    quoteCoin: 'TUSD',
  },
  ETHTUSD: {
    coin: 'ETHTUSD',
    baseCoin: 'ETH',
    quoteCoin: 'TUSD',
  },
  EOSUSDT: {
    coin: 'EOSUSDT',
    baseCoin: 'EOS',
    quoteCoin: 'USDT',
  },
  EOSBNB: {
    coin: 'EOSBNB',
    baseCoin: 'EOS',
    quoteCoin: 'BNB',
  },
  THETABTC: {
    coin: 'THETABTC',
    baseCoin: 'THETA',
    quoteCoin: 'BTC',
  },
  THETAETH: {
    coin: 'THETAETH',
    baseCoin: 'THETA',
    quoteCoin: 'ETH',
  },
  THETABNB: {
    coin: 'THETABNB',
    baseCoin: 'THETA',
    quoteCoin: 'BNB',
  },
  XRPBNB: {
    coin: 'XRPBNB',
    baseCoin: 'XRP',
    quoteCoin: 'BNB',
  },
  TUSDUSDT: {
    coin: 'TUSDUSDT',
    baseCoin: 'TUSD',
    quoteCoin: 'USDT',
  },
  IOTAUSDT: {
    coin: 'IOTAUSDT',
    baseCoin: 'IOTA',
    quoteCoin: 'USDT',
  },
  XLMUSDT: {
    coin: 'XLMUSDT',
    baseCoin: 'XLM',
    quoteCoin: 'USDT',
  },
  TRXBNB: {
    coin: 'TRXBNB',
    baseCoin: 'TRX',
    quoteCoin: 'BNB',
  },
  TRXUSDT: {
    coin: 'TRXUSDT',
    baseCoin: 'TRX',
    quoteCoin: 'USDT',
  },
  ETCUSDT: {
    coin: 'ETCUSDT',
    baseCoin: 'ETC',
    quoteCoin: 'USDT',
  },
  ETCBNB: {
    coin: 'ETCBNB',
    baseCoin: 'ETC',
    quoteCoin: 'BNB',
  },
  VETBTC: {
    coin: 'VETBTC',
    baseCoin: 'VET',
    quoteCoin: 'BTC',
  },
  VETETH: {
    coin: 'VETETH',
    baseCoin: 'VET',
    quoteCoin: 'ETH',
  },
  VETUSDT: {
    coin: 'VETUSDT',
    baseCoin: 'VET',
    quoteCoin: 'USDT',
  },
  VETBNB: {
    coin: 'VETBNB',
    baseCoin: 'VET',
    quoteCoin: 'BNB',
  },
  RVNBTC: {
    coin: 'RVNBTC',
    baseCoin: 'RVN',
    quoteCoin: 'BTC',
  },
  BNBTUSD: {
    coin: 'BNBTUSD',
    baseCoin: 'BNB',
    quoteCoin: 'TUSD',
  },
  XRPTUSD: {
    coin: 'XRPTUSD',
    baseCoin: 'XRP',
    quoteCoin: 'TUSD',
  },
  BNBUSDC: {
    coin: 'BNBUSDC',
    baseCoin: 'BNB',
    quoteCoin: 'USDC',
  },
  BTCUSDC: {
    coin: 'BTCUSDC',
    baseCoin: 'BTC',
    quoteCoin: 'USDC',
  },
  ETHUSDC: {
    coin: 'ETHUSDC',
    baseCoin: 'ETH',
    quoteCoin: 'USDC',
  },
  USDCUSDT: {
    coin: 'USDCUSDT',
    baseCoin: 'USDC',
    quoteCoin: 'USDT',
  },
  ADATUSD: {
    coin: 'ADATUSD',
    baseCoin: 'ADA',
    quoteCoin: 'TUSD',
  },
  TRXXRP: {
    coin: 'TRXXRP',
    baseCoin: 'TRX',
    quoteCoin: 'XRP',
  },
  LINKUSDT: {
    coin: 'LINKUSDT',
    baseCoin: 'LINK',
    quoteCoin: 'USDT',
  },
  LTCTUSD: {
    coin: 'LTCTUSD',
    baseCoin: 'LTC',
    quoteCoin: 'TUSD',
  },
  ZILUSDT: {
    coin: 'ZILUSDT',
    baseCoin: 'ZIL',
    quoteCoin: 'USDT',
  },
  BATUSDT: {
    coin: 'BATUSDT',
    baseCoin: 'BAT',
    quoteCoin: 'USDT',
  },
  XMRBNB: {
    coin: 'XMRBNB',
    baseCoin: 'XMR',
    quoteCoin: 'BNB',
  },
  XMRUSDT: {
    coin: 'XMRUSDT',
    baseCoin: 'XMR',
    quoteCoin: 'USDT',
  },
  ZECUSDT: {
    coin: 'ZECUSDT',
    baseCoin: 'ZEC',
    quoteCoin: 'USDT',
  },
  DASHUSDT: {
    coin: 'DASHUSDT',
    baseCoin: 'DASH',
    quoteCoin: 'USDT',
  },
  THETAUSDT: {
    coin: 'THETAUSDT',
    baseCoin: 'THETA',
    quoteCoin: 'USDT',
  },
  ENJUSDT: {
    coin: 'ENJUSDT',
    baseCoin: 'ENJ',
    quoteCoin: 'USDT',
  },
  MATICBNB: {
    coin: 'MATICBNB',
    baseCoin: 'MATIC',
    quoteCoin: 'BNB',
  },
  MATICBTC: {
    coin: 'MATICBTC',
    baseCoin: 'MATIC',
    quoteCoin: 'BTC',
  },
  MATICUSDT: {
    coin: 'MATICUSDT',
    baseCoin: 'MATIC',
    quoteCoin: 'USDT',
  },
  ATOMBNB: {
    coin: 'ATOMBNB',
    baseCoin: 'ATOM',
    quoteCoin: 'BNB',
  },
  ATOMBTC: {
    coin: 'ATOMBTC',
    baseCoin: 'ATOM',
    quoteCoin: 'BTC',
  },
  ATOMUSDT: {
    coin: 'ATOMUSDT',
    baseCoin: 'ATOM',
    quoteCoin: 'USDT',
  },
  FTMBNB: {
    coin: 'FTMBNB',
    baseCoin: 'FTM',
    quoteCoin: 'BNB',
  },
  FTMBTC: {
    coin: 'FTMBTC',
    baseCoin: 'FTM',
    quoteCoin: 'BTC',
  },
  FTMUSDT: {
    coin: 'FTMUSDT',
    baseCoin: 'FTM',
    quoteCoin: 'USDT',
  },
  ALGOBNB: {
    coin: 'ALGOBNB',
    baseCoin: 'ALGO',
    quoteCoin: 'BNB',
  },
  ALGOBTC: {
    coin: 'ALGOBTC',
    baseCoin: 'ALGO',
    quoteCoin: 'BTC',
  },
  ALGOUSDT: {
    coin: 'ALGOUSDT',
    baseCoin: 'ALGO',
    quoteCoin: 'USDT',
  },
  DOGEBTC: {
    coin: 'DOGEBTC',
    baseCoin: 'DOGE',
    quoteCoin: 'BTC',
  },
  DOGEUSDT: {
    coin: 'DOGEUSDT',
    baseCoin: 'DOGE',
    quoteCoin: 'USDT',
  },
  CHZBNB: {
    coin: 'CHZBNB',
    baseCoin: 'CHZ',
    quoteCoin: 'BNB',
  },
  CHZBTC: {
    coin: 'CHZBTC',
    baseCoin: 'CHZ',
    quoteCoin: 'BTC',
  },
  CHZUSDT: {
    coin: 'CHZUSDT',
    baseCoin: 'CHZ',
    quoteCoin: 'USDT',
  },
  BNBBUSD: {
    coin: 'BNBBUSD',
    baseCoin: 'BNB',
    quoteCoin: 'BUSD',
  },
  BTCBUSD: {
    coin: 'BTCBUSD',
    baseCoin: 'BTC',
    quoteCoin: 'BUSD',
  },
  BUSDUSDT: {
    coin: 'BUSDUSDT',
    baseCoin: 'BUSD',
    quoteCoin: 'USDT',
  },
  XTZBTC: {
    coin: 'XTZBTC',
    baseCoin: 'XTZ',
    quoteCoin: 'BTC',
  },
  XTZUSDT: {
    coin: 'XTZUSDT',
    baseCoin: 'XTZ',
    quoteCoin: 'USDT',
  },
  RVNUSDT: {
    coin: 'RVNUSDT',
    baseCoin: 'RVN',
    quoteCoin: 'USDT',
  },
  HBARBNB: {
    coin: 'HBARBNB',
    baseCoin: 'HBAR',
    quoteCoin: 'BNB',
  },
  HBARBTC: {
    coin: 'HBARBTC',
    baseCoin: 'HBAR',
    quoteCoin: 'BTC',
  },
  HBARUSDT: {
    coin: 'HBARUSDT',
    baseCoin: 'HBAR',
    quoteCoin: 'USDT',
  },
  XRPBUSD: {
    coin: 'XRPBUSD',
    baseCoin: 'XRP',
    quoteCoin: 'BUSD',
  },
  ETHBUSD: {
    coin: 'ETHBUSD',
    baseCoin: 'ETH',
    quoteCoin: 'BUSD',
  },
  LTCBUSD: {
    coin: 'LTCBUSD',
    baseCoin: 'LTC',
    quoteCoin: 'BUSD',
  },
  LINKBUSD: {
    coin: 'LINKBUSD',
    baseCoin: 'LINK',
    quoteCoin: 'BUSD',
  },
  ETCBUSD: {
    coin: 'ETCBUSD',
    baseCoin: 'ETC',
    quoteCoin: 'BUSD',
  },
  STXBNB: {
    coin: 'STXBNB',
    baseCoin: 'STX',
    quoteCoin: 'BNB',
  },
  STXBTC: {
    coin: 'STXBTC',
    baseCoin: 'STX',
    quoteCoin: 'BTC',
  },
  STXUSDT: {
    coin: 'STXUSDT',
    baseCoin: 'STX',
    quoteCoin: 'USDT',
  },
  KAVABNB: {
    coin: 'KAVABNB',
    baseCoin: 'KAVA',
    quoteCoin: 'BNB',
  },
  KAVABTC: {
    coin: 'KAVABTC',
    baseCoin: 'KAVA',
    quoteCoin: 'BTC',
  },
  KAVAUSDT: {
    coin: 'KAVAUSDT',
    baseCoin: 'KAVA',
    quoteCoin: 'USDT',
  },
  TRXBUSD: {
    coin: 'TRXBUSD',
    baseCoin: 'TRX',
    quoteCoin: 'BUSD',
  },
  EOSBUSD: {
    coin: 'EOSBUSD',
    baseCoin: 'EOS',
    quoteCoin: 'BUSD',
  },
  XLMBUSD: {
    coin: 'XLMBUSD',
    baseCoin: 'XLM',
    quoteCoin: 'BUSD',
  },
  ADABUSD: {
    coin: 'ADABUSD',
    baseCoin: 'ADA',
    quoteCoin: 'BUSD',
  },
  BCHBNB: {
    coin: 'BCHBNB',
    baseCoin: 'BCH',
    quoteCoin: 'BNB',
  },
  BCHBTC: {
    coin: 'BCHBTC',
    baseCoin: 'BCH',
    quoteCoin: 'BTC',
  },
  BCHUSDT: {
    coin: 'BCHUSDT',
    baseCoin: 'BCH',
    quoteCoin: 'USDT',
  },
  BCHTUSD: {
    coin: 'BCHTUSD',
    baseCoin: 'BCH',
    quoteCoin: 'TUSD',
  },
  BCHBUSD: {
    coin: 'BCHBUSD',
    baseCoin: 'BCH',
    quoteCoin: 'BUSD',
  },
  QTUMBUSD: {
    coin: 'QTUMBUSD',
    baseCoin: 'QTUM',
    quoteCoin: 'BUSD',
  },
  VETBUSD: {
    coin: 'VETBUSD',
    baseCoin: 'VET',
    quoteCoin: 'BUSD',
  },
  ATOMBUSD: {
    coin: 'ATOMBUSD',
    baseCoin: 'ATOM',
    quoteCoin: 'BUSD',
  },
  DASHBUSD: {
    coin: 'DASHBUSD',
    baseCoin: 'DASH',
    quoteCoin: 'BUSD',
  },
  NEOBUSD: {
    coin: 'NEOBUSD',
    baseCoin: 'NEO',
    quoteCoin: 'BUSD',
  },
  XTZBUSD: {
    coin: 'XTZBUSD',
    baseCoin: 'XTZ',
    quoteCoin: 'BUSD',
  },
  BATBUSD: {
    coin: 'BATBUSD',
    baseCoin: 'BAT',
    quoteCoin: 'BUSD',
  },
  ENJBUSD: {
    coin: 'ENJBUSD',
    baseCoin: 'ENJ',
    quoteCoin: 'BUSD',
  },
  RVNBUSD: {
    coin: 'RVNBUSD',
    baseCoin: 'RVN',
    quoteCoin: 'BUSD',
  },
  ALGOBUSD: {
    coin: 'ALGOBUSD',
    baseCoin: 'ALGO',
    quoteCoin: 'BUSD',
  },
  XMRBUSD: {
    coin: 'XMRBUSD',
    baseCoin: 'XMR',
    quoteCoin: 'BUSD',
  },
  ZECBUSD: {
    coin: 'ZECBUSD',
    baseCoin: 'ZEC',
    quoteCoin: 'BUSD',
  },
  SOLBNB: {
    coin: 'SOLBNB',
    baseCoin: 'SOL',
    quoteCoin: 'BNB',
  },
  SOLBTC: {
    coin: 'SOLBTC',
    baseCoin: 'SOL',
    quoteCoin: 'BTC',
  },
  SOLUSDT: {
    coin: 'SOLUSDT',
    baseCoin: 'SOL',
    quoteCoin: 'USDT',
  },
  SOLBUSD: {
    coin: 'SOLBUSD',
    baseCoin: 'SOL',
    quoteCoin: 'BUSD',
  },
  HBARBUSD: {
    coin: 'HBARBUSD',
    baseCoin: 'HBAR',
    quoteCoin: 'BUSD',
  },
  MATICBUSD: {
    coin: 'MATICBUSD',
    baseCoin: 'MATIC',
    quoteCoin: 'BUSD',
  },
  ZILBUSD: {
    coin: 'ZILBUSD',
    baseCoin: 'ZIL',
    quoteCoin: 'BUSD',
  },
  LRCBUSD: {
    coin: 'LRCBUSD',
    baseCoin: 'LRC',
    quoteCoin: 'BUSD',
  },
  LRCUSDT: {
    coin: 'LRCUSDT',
    baseCoin: 'LRC',
    quoteCoin: 'USDT',
  },
  COMPBTC: {
    coin: 'COMPBTC',
    baseCoin: 'COMP',
    quoteCoin: 'BTC',
  },
  COMPBUSD: {
    coin: 'COMPBUSD',
    baseCoin: 'COMP',
    quoteCoin: 'BUSD',
  },
  COMPUSDT: {
    coin: 'COMPUSDT',
    baseCoin: 'COMP',
    quoteCoin: 'USDT',
  },
  SNXBTC: {
    coin: 'SNXBTC',
    baseCoin: 'SNX',
    quoteCoin: 'BTC',
  },
  SNXBNB: {
    coin: 'SNXBNB',
    baseCoin: 'SNX',
    quoteCoin: 'BNB',
  },
  SNXBUSD: {
    coin: 'SNXBUSD',
    baseCoin: 'SNX',
    quoteCoin: 'BUSD',
  },
  SNXUSDT: {
    coin: 'SNXUSDT',
    baseCoin: 'SNX',
    quoteCoin: 'USDT',
  },
  MKRBTC: {
    coin: 'MKRBTC',
    baseCoin: 'MKR',
    quoteCoin: 'BTC',
  },
  MKRUSDT: {
    coin: 'MKRUSDT',
    baseCoin: 'MKR',
    quoteCoin: 'USDT',
  },
  MKRBUSD: {
    coin: 'MKRBUSD',
    baseCoin: 'MKR',
    quoteCoin: 'BUSD',
  },
  RUNEBNB: {
    coin: 'RUNEBNB',
    baseCoin: 'RUNE',
    quoteCoin: 'BNB',
  },
  RUNEBTC: {
    coin: 'RUNEBTC',
    baseCoin: 'RUNE',
    quoteCoin: 'BTC',
  },
  RUNEBUSD: {
    coin: 'RUNEBUSD',
    baseCoin: 'RUNE',
    quoteCoin: 'BUSD',
  },
  MANABUSD: {
    coin: 'MANABUSD',
    baseCoin: 'MANA',
    quoteCoin: 'BUSD',
  },
  DOGEBUSD: {
    coin: 'DOGEBUSD',
    baseCoin: 'DOGE',
    quoteCoin: 'BUSD',
  },
  IOTABUSD: {
    coin: 'IOTABUSD',
    baseCoin: 'IOTA',
    quoteCoin: 'BUSD',
  },
  MANAUSDT: {
    coin: 'MANAUSDT',
    baseCoin: 'MANA',
    quoteCoin: 'USDT',
  },
  BTCDAI: {
    coin: 'BTCDAI',
    baseCoin: 'BTC',
    quoteCoin: 'DAI',
  },
  ETHDAI: {
    coin: 'ETHDAI',
    baseCoin: 'ETH',
    quoteCoin: 'DAI',
  },
  BNBDAI: {
    coin: 'BNBDAI',
    baseCoin: 'BNB',
    quoteCoin: 'DAI',
  },
  USDTDAI: {
    coin: 'USDTDAI',
    baseCoin: 'USDT',
    quoteCoin: 'DAI',
  },
  BUSDDAI: {
    coin: 'BUSDDAI',
    baseCoin: 'BUSD',
    quoteCoin: 'DAI',
  },
  CRVBTC: {
    coin: 'CRVBTC',
    baseCoin: 'CRV',
    quoteCoin: 'BTC',
  },
  CRVBUSD: {
    coin: 'CRVBUSD',
    baseCoin: 'CRV',
    quoteCoin: 'BUSD',
  },
  CRVUSDT: {
    coin: 'CRVUSDT',
    baseCoin: 'CRV',
    quoteCoin: 'USDT',
  },
  SANDBNB: {
    coin: 'SANDBNB',
    baseCoin: 'SAND',
    quoteCoin: 'BNB',
  },
  SANDBTC: {
    coin: 'SANDBTC',
    baseCoin: 'SAND',
    quoteCoin: 'BTC',
  },
  SANDUSDT: {
    coin: 'SANDUSDT',
    baseCoin: 'SAND',
    quoteCoin: 'USDT',
  },
  SANDBUSD: {
    coin: 'SANDBUSD',
    baseCoin: 'SAND',
    quoteCoin: 'BUSD',
  },
  DOTBNB: {
    coin: 'DOTBNB',
    baseCoin: 'DOT',
    quoteCoin: 'BNB',
  },
  DOTBTC: {
    coin: 'DOTBTC',
    baseCoin: 'DOT',
    quoteCoin: 'BTC',
  },
  DOTBUSD: {
    coin: 'DOTBUSD',
    baseCoin: 'DOT',
    quoteCoin: 'BUSD',
  },
  DOTUSDT: {
    coin: 'DOTUSDT',
    baseCoin: 'DOT',
    quoteCoin: 'USDT',
  },
  PAXGBNB: {
    coin: 'PAXGBNB',
    baseCoin: 'PAXG',
    quoteCoin: 'BNB',
  },
  PAXGBTC: {
    coin: 'PAXGBTC',
    baseCoin: 'PAXG',
    quoteCoin: 'BTC',
  },
  PAXGBUSD: {
    coin: 'PAXGBUSD',
    baseCoin: 'PAXG',
    quoteCoin: 'BUSD',
  },
  PAXGUSDT: {
    coin: 'PAXGUSDT',
    baseCoin: 'PAXG',
    quoteCoin: 'USDT',
  },
  WBTCBTC: {
    coin: 'WBTCBTC',
    baseCoin: 'WBTC',
    quoteCoin: 'BTC',
  },
  WBTCETH: {
    coin: 'WBTCETH',
    baseCoin: 'WBTC',
    quoteCoin: 'ETH',
  },
  EGLDBNB: {
    coin: 'EGLDBNB',
    baseCoin: 'EGLD',
    quoteCoin: 'BNB',
  },
  EGLDBTC: {
    coin: 'EGLDBTC',
    baseCoin: 'EGLD',
    quoteCoin: 'BTC',
  },
  EGLDBUSD: {
    coin: 'EGLDBUSD',
    baseCoin: 'EGLD',
    quoteCoin: 'BUSD',
  },
  EGLDUSDT: {
    coin: 'EGLDUSDT',
    baseCoin: 'EGLD',
    quoteCoin: 'USDT',
  },
  RUNEUSDT: {
    coin: 'RUNEUSDT',
    baseCoin: 'RUNE',
    quoteCoin: 'USDT',
  },
  UNIBNB: {
    coin: 'UNIBNB',
    baseCoin: 'UNI',
    quoteCoin: 'BNB',
  },
  UNIBTC: {
    coin: 'UNIBTC',
    baseCoin: 'UNI',
    quoteCoin: 'BTC',
  },
  UNIBUSD: {
    coin: 'UNIBUSD',
    baseCoin: 'UNI',
    quoteCoin: 'BUSD',
  },
  UNIUSDT: {
    coin: 'UNIUSDT',
    baseCoin: 'UNI',
    quoteCoin: 'USDT',
  },
  AVAXBNB: {
    coin: 'AVAXBNB',
    baseCoin: 'AVAX',
    quoteCoin: 'BNB',
  },
  AVAXBTC: {
    coin: 'AVAXBTC',
    baseCoin: 'AVAX',
    quoteCoin: 'BTC',
  },
  AVAXBUSD: {
    coin: 'AVAXBUSD',
    baseCoin: 'AVAX',
    quoteCoin: 'BUSD',
  },
  AVAXUSDT: {
    coin: 'AVAXUSDT',
    baseCoin: 'AVAX',
    quoteCoin: 'USDT',
  },
  CAKEBNB: {
    coin: 'CAKEBNB',
    baseCoin: 'CAKE',
    quoteCoin: 'BNB',
  },
  CAKEBUSD: {
    coin: 'CAKEBUSD',
    baseCoin: 'CAKE',
    quoteCoin: 'BUSD',
  },
  AAVEBNB: {
    coin: 'AAVEBNB',
    baseCoin: 'AAVE',
    quoteCoin: 'BNB',
  },
  AAVEBTC: {
    coin: 'AAVEBTC',
    baseCoin: 'AAVE',
    quoteCoin: 'BTC',
  },
  AAVEETH: {
    coin: 'AAVEETH',
    baseCoin: 'AAVE',
    quoteCoin: 'ETH',
  },
  AAVEBUSD: {
    coin: 'AAVEBUSD',
    baseCoin: 'AAVE',
    quoteCoin: 'BUSD',
  },
  AAVEUSDT: {
    coin: 'AAVEUSDT',
    baseCoin: 'AAVE',
    quoteCoin: 'USDT',
  },
  NEARBNB: {
    coin: 'NEARBNB',
    baseCoin: 'NEAR',
    quoteCoin: 'BNB',
  },
  NEARBTC: {
    coin: 'NEARBTC',
    baseCoin: 'NEAR',
    quoteCoin: 'BTC',
  },
  NEARBUSD: {
    coin: 'NEARBUSD',
    baseCoin: 'NEAR',
    quoteCoin: 'BUSD',
  },
  NEARUSDT: {
    coin: 'NEARUSDT',
    baseCoin: 'NEAR',
    quoteCoin: 'USDT',
  },
  FILBNB: {
    coin: 'FILBNB',
    baseCoin: 'FIL',
    quoteCoin: 'BNB',
  },
  FILBTC: {
    coin: 'FILBTC',
    baseCoin: 'FIL',
    quoteCoin: 'BTC',
  },
  FILBUSD: {
    coin: 'FILBUSD',
    baseCoin: 'FIL',
    quoteCoin: 'BUSD',
  },
  FILUSDT: {
    coin: 'FILUSDT',
    baseCoin: 'FIL',
    quoteCoin: 'USDT',
  },
  INJBNB: {
    coin: 'INJBNB',
    baseCoin: 'INJ',
    quoteCoin: 'BNB',
  },
  INJBTC: {
    coin: 'INJBTC',
    baseCoin: 'INJ',
    quoteCoin: 'BTC',
  },
  INJBUSD: {
    coin: 'INJBUSD',
    baseCoin: 'INJ',
    quoteCoin: 'BUSD',
  },
  INJUSDT: {
    coin: 'INJUSDT',
    baseCoin: 'INJ',
    quoteCoin: 'USDT',
  },
  AXSBNB: {
    coin: 'AXSBNB',
    baseCoin: 'AXS',
    quoteCoin: 'BNB',
  },
  AXSBTC: {
    coin: 'AXSBTC',
    baseCoin: 'AXS',
    quoteCoin: 'BTC',
  },
  AXSBUSD: {
    coin: 'AXSBUSD',
    baseCoin: 'AXS',
    quoteCoin: 'BUSD',
  },
  AXSUSDT: {
    coin: 'AXSUSDT',
    baseCoin: 'AXS',
    quoteCoin: 'USDT',
  },
  ROSEBTC: {
    coin: 'ROSEBTC',
    baseCoin: 'ROSE',
    quoteCoin: 'BTC',
  },
  ROSEBUSD: {
    coin: 'ROSEBUSD',
    baseCoin: 'ROSE',
    quoteCoin: 'BUSD',
  },
  ROSEUSDT: {
    coin: 'ROSEUSDT',
    baseCoin: 'ROSE',
    quoteCoin: 'USDT',
  },
  XEMUSDT: {
    coin: 'XEMUSDT',
    baseCoin: 'XEM',
    quoteCoin: 'USDT',
  },
  GRTBTC: {
    coin: 'GRTBTC',
    baseCoin: 'GRT',
    quoteCoin: 'BTC',
  },
  GRTETH: {
    coin: 'GRTETH',
    baseCoin: 'GRT',
    quoteCoin: 'ETH',
  },
  GRTUSDT: {
    coin: 'GRTUSDT',
    baseCoin: 'GRT',
    quoteCoin: 'USDT',
  },
  '1INCHBTC': {
    coin: '1INCHBTC',
    baseCoin: '1INCH',
    quoteCoin: 'BTC',
  },
  '1INCHUSDT': {
    coin: '1INCHUSDT',
    baseCoin: '1INCH',
    quoteCoin: 'USDT',
  },
  CELOBTC: {
    coin: 'CELOBTC',
    baseCoin: 'CELO',
    quoteCoin: 'BTC',
  },
  CELOUSDT: {
    coin: 'CELOUSDT',
    baseCoin: 'CELO',
    quoteCoin: 'USDT',
  },
  TUSDBUSD: {
    coin: 'TUSDBUSD',
    baseCoin: 'TUSD',
    quoteCoin: 'BUSD',
  },
  TWTBTC: {
    coin: 'TWTBTC',
    baseCoin: 'TWT',
    quoteCoin: 'BTC',
  },
  TWTBUSD: {
    coin: 'TWTBUSD',
    baseCoin: 'TWT',
    quoteCoin: 'BUSD',
  },
  TWTUSDT: {
    coin: 'TWTUSDT',
    baseCoin: 'TWT',
    quoteCoin: 'USDT',
  },
  FXSBTC: {
    coin: 'FXSBTC',
    baseCoin: 'FXS',
    quoteCoin: 'BTC',
  },
  FXSBUSD: {
    coin: 'FXSBUSD',
    baseCoin: 'FXS',
    quoteCoin: 'BUSD',
  },
  CAKEBTC: {
    coin: 'CAKEBTC',
    baseCoin: 'CAKE',
    quoteCoin: 'BTC',
  },
  CAKEUSDT: {
    coin: 'CAKEUSDT',
    baseCoin: 'CAKE',
    quoteCoin: 'USDT',
  },
  '1INCHBUSD': {
    coin: '1INCHBUSD',
    baseCoin: '1INCH',
    quoteCoin: 'BUSD',
  },
  GRTBUSD: {
    coin: 'GRTBUSD',
    baseCoin: 'GRT',
    quoteCoin: 'BUSD',
  },
  CHZBUSD: {
    coin: 'CHZBUSD',
    baseCoin: 'CHZ',
    quoteCoin: 'BUSD',
  },
  CFXBTC: {
    coin: 'CFXBTC',
    baseCoin: 'CFX',
    quoteCoin: 'BTC',
  },
  CFXBUSD: {
    coin: 'CFXBUSD',
    baseCoin: 'CFX',
    quoteCoin: 'BUSD',
  },
  CFXUSDT: {
    coin: 'CFXUSDT',
    baseCoin: 'CFX',
    quoteCoin: 'USDT',
  },
  SHIBUSDT: {
    coin: 'SHIBUSDT',
    baseCoin: 'SHIB',
    quoteCoin: 'USDT',
  },
  SHIBBUSD: {
    coin: 'SHIBBUSD',
    baseCoin: 'SHIB',
    quoteCoin: 'BUSD',
  },
  ICPBTC: {
    coin: 'ICPBTC',
    baseCoin: 'ICP',
    quoteCoin: 'BTC',
  },
  ICPBNB: {
    coin: 'ICPBNB',
    baseCoin: 'ICP',
    quoteCoin: 'BNB',
  },
  ICPBUSD: {
    coin: 'ICPBUSD',
    baseCoin: 'ICP',
    quoteCoin: 'BUSD',
  },
  ICPUSDT: {
    coin: 'ICPUSDT',
    baseCoin: 'ICP',
    quoteCoin: 'USDT',
  },
  MASKBNB: {
    coin: 'MASKBNB',
    baseCoin: 'MASK',
    quoteCoin: 'BNB',
  },
  MASKBUSD: {
    coin: 'MASKBUSD',
    baseCoin: 'MASK',
    quoteCoin: 'BUSD',
  },
  MASKUSDT: {
    coin: 'MASKUSDT',
    baseCoin: 'MASK',
    quoteCoin: 'USDT',
  },
  AGIXBTC: {
    coin: 'AGIXBTC',
    baseCoin: 'AGIX',
    quoteCoin: 'BTC',
  },
  FTMBUSD: {
    coin: 'FTMBUSD',
    baseCoin: 'FTM',
    quoteCoin: 'BUSD',
  },
  THETABUSD: {
    coin: 'THETABUSD',
    baseCoin: 'THETA',
    quoteCoin: 'BUSD',
  },
  KAVABUSD: {
    coin: 'KAVABUSD',
    baseCoin: 'KAVA',
    quoteCoin: 'BUSD',
  },
  FTTBUSD: {
    coin: 'FTTBUSD',
    baseCoin: 'FTT',
    quoteCoin: 'BUSD',
  },
  KLAYBTC: {
    coin: 'KLAYBTC',
    baseCoin: 'KLAY',
    quoteCoin: 'BTC',
  },
  KLAYBUSD: {
    coin: 'KLAYBUSD',
    baseCoin: 'KLAY',
    quoteCoin: 'BUSD',
  },
  KLAYUSDT: {
    coin: 'KLAYUSDT',
    baseCoin: 'KLAY',
    quoteCoin: 'USDT',
  },
  QNTBTC: {
    coin: 'QNTBTC',
    baseCoin: 'QNT',
    quoteCoin: 'BTC',
  },
  QNTBUSD: {
    coin: 'QNTBUSD',
    baseCoin: 'QNT',
    quoteCoin: 'BUSD',
  },
  QNTUSDT: {
    coin: 'QNTUSDT',
    baseCoin: 'QNT',
    quoteCoin: 'USDT',
  },
  FLOWBTC: {
    coin: 'FLOWBTC',
    baseCoin: 'FLOW',
    quoteCoin: 'BTC',
  },
  FLOWBNB: {
    coin: 'FLOWBNB',
    baseCoin: 'FLOW',
    quoteCoin: 'BNB',
  },
  FLOWBUSD: {
    coin: 'FLOWBUSD',
    baseCoin: 'FLOW',
    quoteCoin: 'BUSD',
  },
  FLOWUSDT: {
    coin: 'FLOWUSDT',
    baseCoin: 'FLOW',
    quoteCoin: 'USDT',
  },
  XECBUSD: {
    coin: 'XECBUSD',
    baseCoin: 'XEC',
    quoteCoin: 'BUSD',
  },
  MINABTC: {
    coin: 'MINABTC',
    baseCoin: 'MINA',
    quoteCoin: 'BTC',
  },
  MINABUSD: {
    coin: 'MINABUSD',
    baseCoin: 'MINA',
    quoteCoin: 'BUSD',
  },
  MINAUSDT: {
    coin: 'MINAUSDT',
    baseCoin: 'MINA',
    quoteCoin: 'USDT',
  },
  GNOUSDT: {
    coin: 'GNOUSDT',
    baseCoin: 'GNO',
    quoteCoin: 'USDT',
  },
  XECUSDT: {
    coin: 'XECUSDT',
    baseCoin: 'XEC',
    quoteCoin: 'USDT',
  },
  DYDXUSDT: {
    coin: 'DYDXUSDT',
    baseCoin: 'DYDX',
    quoteCoin: 'USDT',
  },
  DYDXBUSD: {
    coin: 'DYDXBUSD',
    baseCoin: 'DYDX',
    quoteCoin: 'BUSD',
  },
  DYDXBNB: {
    coin: 'DYDXBNB',
    baseCoin: 'DYDX',
    quoteCoin: 'BNB',
  },
  DYDXBTC: {
    coin: 'DYDXBTC',
    baseCoin: 'DYDX',
    quoteCoin: 'BTC',
  },
  USDPUSDT: {
    coin: 'USDPUSDT',
    baseCoin: 'USDP',
    quoteCoin: 'USDT',
  },
  GALAUSDT: {
    coin: 'GALAUSDT',
    baseCoin: 'GALA',
    quoteCoin: 'USDT',
  },
  GALABUSD: {
    coin: 'GALABUSD',
    baseCoin: 'GALA',
    quoteCoin: 'BUSD',
  },
  GALABNB: {
    coin: 'GALABNB',
    baseCoin: 'GALA',
    quoteCoin: 'BNB',
  },
  GALABTC: {
    coin: 'GALABTC',
    baseCoin: 'GALA',
    quoteCoin: 'BTC',
  },
  STXBUSD: {
    coin: 'STXBUSD',
    baseCoin: 'STX',
    quoteCoin: 'BUSD',
  },
  AXSETH: {
    coin: 'AXSETH',
    baseCoin: 'AXS',
    quoteCoin: 'ETH',
  },
  FTMETH: {
    coin: 'FTMETH',
    baseCoin: 'FTM',
    quoteCoin: 'ETH',
  },
  SOLETH: {
    coin: 'SOLETH',
    baseCoin: 'SOL',
    quoteCoin: 'ETH',
  },
  CELOBUSD: {
    coin: 'CELOBUSD',
    baseCoin: 'CELO',
    quoteCoin: 'BUSD',
  },
  SHIBDOGE: {
    coin: 'SHIBDOGE',
    baseCoin: 'SHIB',
    quoteCoin: 'DOGE',
  },
  SANDETH: {
    coin: 'SANDETH',
    baseCoin: 'SAND',
    quoteCoin: 'ETH',
  },
  DOTETH: {
    coin: 'DOTETH',
    baseCoin: 'DOT',
    quoteCoin: 'ETH',
  },
  MATICETH: {
    coin: 'MATICETH',
    baseCoin: 'MATIC',
    quoteCoin: 'ETH',
  },
  AVAXETH: {
    coin: 'AVAXETH',
    baseCoin: 'AVAX',
    quoteCoin: 'ETH',
  },
  GALAETH: {
    coin: 'GALAETH',
    baseCoin: 'GALA',
    quoteCoin: 'ETH',
  },
  RNDRBTC: {
    coin: 'RNDRBTC',
    baseCoin: 'RNDR',
    quoteCoin: 'BTC',
  },
  RNDRUSDT: {
    coin: 'RNDRUSDT',
    baseCoin: 'RNDR',
    quoteCoin: 'USDT',
  },
  RNDRBUSD: {
    coin: 'RNDRBUSD',
    baseCoin: 'RNDR',
    quoteCoin: 'BUSD',
  },
  FXSUSDT: {
    coin: 'FXSUSDT',
    baseCoin: 'FXS',
    quoteCoin: 'USDT',
  },
  CVXBTC: {
    coin: 'CVXBTC',
    baseCoin: 'CVX',
    quoteCoin: 'BTC',
  },
  CVXBUSD: {
    coin: 'CVXBUSD',
    baseCoin: 'CVX',
    quoteCoin: 'BUSD',
  },
  CVXUSDT: {
    coin: 'CVXUSDT',
    baseCoin: 'CVX',
    quoteCoin: 'USDT',
  },
  LINKBNB: {
    coin: 'LINKBNB',
    baseCoin: 'LINK',
    quoteCoin: 'BNB',
  },
  ATOMETH: {
    coin: 'ATOMETH',
    baseCoin: 'ATOM',
    quoteCoin: 'ETH',
  },
  EGLDETH: {
    coin: 'EGLDETH',
    baseCoin: 'EGLD',
    quoteCoin: 'ETH',
  },
  ICPETH: {
    coin: 'ICPETH',
    baseCoin: 'ICP',
    quoteCoin: 'ETH',
  },
  NEARETH: {
    coin: 'NEARETH',
    baseCoin: 'NEAR',
    quoteCoin: 'ETH',
  },
  LRCBNB: {
    coin: 'LRCBNB',
    baseCoin: 'LRC',
    quoteCoin: 'BNB',
  },
  IMXBTC: {
    coin: 'IMXBTC',
    baseCoin: 'IMX',
    quoteCoin: 'BTC',
  },
  IMXBUSD: {
    coin: 'IMXBUSD',
    baseCoin: 'IMX',
    quoteCoin: 'BUSD',
  },
  IMXUSDT: {
    coin: 'IMXUSDT',
    baseCoin: 'IMX',
    quoteCoin: 'USDT',
  },
  ROSEETH: {
    coin: 'ROSEETH',
    baseCoin: 'ROSE',
    quoteCoin: 'ETH',
  },
  UNIETH: {
    coin: 'UNIETH',
    baseCoin: 'UNI',
    quoteCoin: 'ETH',
  },
  CRVETH: {
    coin: 'CRVETH',
    baseCoin: 'CRV',
    quoteCoin: 'ETH',
  },
  KAVAETH: {
    coin: 'KAVAETH',
    baseCoin: 'KAVA',
    quoteCoin: 'ETH',
  },
  WOOBTC: {
    coin: 'WOOBTC',
    baseCoin: 'WOO',
    quoteCoin: 'BTC',
  },
  WOOBNB: {
    coin: 'WOOBNB',
    baseCoin: 'WOO',
    quoteCoin: 'BNB',
  },
  WOOBUSD: {
    coin: 'WOOBUSD',
    baseCoin: 'WOO',
    quoteCoin: 'BUSD',
  },
  WOOUSDT: {
    coin: 'WOOUSDT',
    baseCoin: 'WOO',
    quoteCoin: 'USDT',
  },
  APEUSDT: {
    coin: 'APEUSDT',
    baseCoin: 'APE',
    quoteCoin: 'USDT',
  },
  APEBUSD: {
    coin: 'APEBUSD',
    baseCoin: 'APE',
    quoteCoin: 'BUSD',
  },
  APEBTC: {
    coin: 'APEBTC',
    baseCoin: 'APE',
    quoteCoin: 'BTC',
  },
  APEBNB: {
    coin: 'APEBNB',
    baseCoin: 'APE',
    quoteCoin: 'BNB',
  },
  IMXBNB: {
    coin: 'IMXBNB',
    baseCoin: 'IMX',
    quoteCoin: 'BNB',
  },
  RUNEETH: {
    coin: 'RUNEETH',
    baseCoin: 'RUNE',
    quoteCoin: 'ETH',
  },
  APEETH: {
    coin: 'APEETH',
    baseCoin: 'APE',
    quoteCoin: 'ETH',
  },
  NEXOUSDT: {
    coin: 'NEXOUSDT',
    baseCoin: 'NEXO',
    quoteCoin: 'USDT',
  },
  NEXOBTC: {
    coin: 'NEXOBTC',
    baseCoin: 'NEXO',
    quoteCoin: 'BTC',
  },
  LDOBUSD: {
    coin: 'LDOBUSD',
    baseCoin: 'LDO',
    quoteCoin: 'BUSD',
  },
  LDOUSDT: {
    coin: 'LDOUSDT',
    baseCoin: 'LDO',
    quoteCoin: 'USDT',
  },
  LDOBTC: {
    coin: 'LDOBTC',
    baseCoin: 'LDO',
    quoteCoin: 'BTC',
  },
  ALGOETH: {
    coin: 'ALGOETH',
    baseCoin: 'ALGO',
    quoteCoin: 'ETH',
  },
  LUNCBUSD: {
    coin: 'LUNCBUSD',
    baseCoin: 'LUNC',
    quoteCoin: 'BUSD',
  },
  OPBTC: {
    coin: 'OPBTC',
    baseCoin: 'OP',
    quoteCoin: 'BTC',
  },
  OPBUSD: {
    coin: 'OPBUSD',
    baseCoin: 'OP',
    quoteCoin: 'BUSD',
  },
  OPUSDT: {
    coin: 'OPUSDT',
    baseCoin: 'OP',
    quoteCoin: 'USDT',
  },
  OPBNB: {
    coin: 'OPBNB',
    baseCoin: 'OP',
    quoteCoin: 'BNB',
  },
  SNXETH: {
    coin: 'SNXETH',
    baseCoin: 'SNX',
    quoteCoin: 'ETH',
  },
  WBTCBUSD: {
    coin: 'WBTCBUSD',
    baseCoin: 'WBTC',
    quoteCoin: 'BUSD',
  },
  OPETH: {
    coin: 'OPETH',
    baseCoin: 'OP',
    quoteCoin: 'ETH',
  },
  FILETH: {
    coin: 'FILETH',
    baseCoin: 'FIL',
    quoteCoin: 'ETH',
  },
  LUNCUSDT: {
    coin: 'LUNCUSDT',
    baseCoin: 'LUNC',
    quoteCoin: 'USDT',
  },
  GMXBTC: {
    coin: 'GMXBTC',
    baseCoin: 'GMX',
    quoteCoin: 'BTC',
  },
  GMXBUSD: {
    coin: 'GMXBUSD',
    baseCoin: 'GMX',
    quoteCoin: 'BUSD',
  },
  GMXUSDT: {
    coin: 'GMXUSDT',
    baseCoin: 'GMX',
    quoteCoin: 'USDT',
  },
  AGIXBUSD: {
    coin: 'AGIXBUSD',
    baseCoin: 'AGIX',
    quoteCoin: 'BUSD',
  },
  APTBTC: {
    coin: 'APTBTC',
    baseCoin: 'APT',
    quoteCoin: 'BTC',
  },
  APTUSDT: {
    coin: 'APTUSDT',
    baseCoin: 'APT',
    quoteCoin: 'USDT',
  },
  APTBUSD: {
    coin: 'APTBUSD',
    baseCoin: 'APT',
    quoteCoin: 'BUSD',
  },
  RPLBTC: {
    coin: 'RPLBTC',
    baseCoin: 'RPL',
    quoteCoin: 'BTC',
  },
  RPLBUSD: {
    coin: 'RPLBUSD',
    baseCoin: 'RPL',
    quoteCoin: 'BUSD',
  },
  RPLUSDT: {
    coin: 'RPLUSDT',
    baseCoin: 'RPL',
    quoteCoin: 'USDT',
  },
  AGIXUSDT: {
    coin: 'AGIXUSDT',
    baseCoin: 'AGIX',
    quoteCoin: 'USDT',
  },
  APTETH: {
    coin: 'APTETH',
    baseCoin: 'APT',
    quoteCoin: 'ETH',
  },
  ARBBTC: {
    coin: 'ARBBTC',
    baseCoin: 'ARB',
    quoteCoin: 'BTC',
  },
  ARBUSDT: {
    coin: 'ARBUSDT',
    baseCoin: 'ARB',
    quoteCoin: 'USDT',
  },
  ARBTUSD: {
    coin: 'ARBTUSD',
    baseCoin: 'ARB',
    quoteCoin: 'TUSD',
  },
  LDOTUSD: {
    coin: 'LDOTUSD',
    baseCoin: 'LDO',
    quoteCoin: 'TUSD',
  },
  MATICTUSD: {
    coin: 'MATICTUSD',
    baseCoin: 'MATIC',
    quoteCoin: 'TUSD',
  },
  OPTUSD: {
    coin: 'OPTUSD',
    baseCoin: 'OP',
    quoteCoin: 'TUSD',
  },
  SOLTUSD: {
    coin: 'SOLTUSD',
    baseCoin: 'SOL',
    quoteCoin: 'TUSD',
  },
  DOGETUSD: {
    coin: 'DOGETUSD',
    baseCoin: 'DOGE',
    quoteCoin: 'TUSD',
  },
  WBTCUSDT: {
    coin: 'WBTCUSDT',
    baseCoin: 'WBTC',
    quoteCoin: 'USDT',
  },
  SUIUSDT: {
    coin: 'SUIUSDT',
    baseCoin: 'SUI',
    quoteCoin: 'USDT',
  },
  SUITUSD: {
    coin: 'SUITUSD',
    baseCoin: 'SUI',
    quoteCoin: 'TUSD',
  },
  SUIBTC: {
    coin: 'SUIBTC',
    baseCoin: 'SUI',
    quoteCoin: 'BTC',
  },
  SUIBNB: {
    coin: 'SUIBNB',
    baseCoin: 'SUI',
    quoteCoin: 'BNB',
  },
  PEPEUSDT: {
    coin: 'PEPEUSDT',
    baseCoin: 'PEPE',
    quoteCoin: 'USDT',
  },
  PEPETUSD: {
    coin: 'PEPETUSD',
    baseCoin: 'PEPE',
    quoteCoin: 'TUSD',
  },
};
